import React from 'react';
import API from "../../../Services/BaseService";
import { useHistory } from "react-router-dom";
import ls from 'local-storage';
import { useState } from 'react';
import { useEffect } from 'react';
import DatePicker from "react-datepicker";
import { getMonth, getYear } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import StateAndCity from '../../../Component/StateAndCity/StateAndCity';
import { useForm } from "react-hook-form";
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks";
import { useSelector } from 'react-redux';
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import StateAndCitySearch from '../../../Component/StateAndCity/StateAndCitySearch';
import PageNotFound from '../../FallBackUI/PageNotFound';
import { Button } from 'antd';

const AddLegalAccount = () => {

    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step));
    const [startDate, setStartDate] = useState(new Date());
    const years = range(1990, getYear(new Date()) + 1, 1);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const dateFormat = 'MM/DD/YYYY';
    const customFormat = value => `${value.format(dateFormat)}`;
    const [etax, setTax] = useState("1");
    const [edealerExp, setDealerExp] = useState("1");

    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }
    const yesterday = moment().subtract(1, 'day');
    const disablePastDt = current => {
        return current.isAfter(yesterday);
    };
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("")

    const userDetails = ls.get('userDetails');
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [EINnumber, setEINnumber] = useState("");
    const [dealershiplicense, setDealershiplicense] = useState("");
    const [taxid, setTaxid] = useState("");
    const [address, setAddress] = useState("");
    const [dealershipLicenseexp, setDealershiplicenseexp] = useState("");
    const [taxidexp, setTaxidexp] = useState("");
    const [legalBusinessname, setLegalBusinessname] = useState("");
    const [stateName, setStateName] = useState("");
    const [cityName, setCityName] = useState("");
    const [zipCodeId, setZipcodeId] = useState("");

    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [EINnumberError, setEINnumberError] = useState("");
    const [dealershiplicenseError, setDealershiplicenseError] = useState("");
    const [taxidError, setTaxidError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [dealershipLicenseexpError, setDealershiplicenseexpError] = useState("");
    const [taxidexpError, setTaxidexpError] = useState("");
    const [legalBusinessnameError, setLegalBusinessnameError] = useState("");
    const [stateAndCityError, setStateAndCityError] = useState("");
    const [state, setState] = useState("1");
    const [city, setCity] = useState("1");
    const [zipcode, setZipcode] = useState("1");

    const [idStatename, setIdStatename] = useState(null);
    const [idCityname, setIdCityname] = useState(null);
    const [idZipcodename, setidZipcodename] = useState(null);
    const [stateCityFlag, setStateCityFlag] = useState("");
    const successData = useSelector(state => state.LoginReducer.payload);

    const [addErrors, setAddErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const [confirmationFlag, setConfirmationFlag] = useState(false);

    const confirmationPopup = () => {

        setConfirmationFlag(!confirmationFlag)

    }

    const customButtonStyle = {
        backgroundColor: "RGB(189,6,44)",
        color: "white",
        height: '40px'
    };


    const onhandleSubmit = (data) => {
        // setOpenLoader(true);
        // event.preventDefault();        

        setFirstNameError("")
        setLastNameError("")
        setLegalBusinessnameError("")
        setEINnumberError("")
        setDealershiplicenseError("")
        setTaxidError("")
        setAddressError("")
        setDealershiplicenseexpError("")
        setTaxidexpError("")
        setStateAndCityError("")


        let request = {
            seller_dealer_id: successData.seller_dealer_id,
            first_name: firstname,
            last_name: lastname,
            ein_no: EINnumber,
            seller_license: dealershiplicense,
            tax_id: taxid,
            tax_id_exp: moment(taxidexp).format("YYYY-MM-DD"),
            seller_license_exp: moment(dealershipLicenseexp).format("YYYY-MM-DD"),
            state_id: stateCityFlag === "" ? idStatename : "",
            city_id: stateCityFlag === "" ? idCityname : "",
            zipcode_id: stateCityFlag === "" ? idZipcodename : "",
            state_name: stateCityFlag !== "" ? idStatename : "",
            city_name: stateCityFlag !== "" ? idCityname : "",
            zipcode: stateCityFlag !== "" ? idZipcodename : "",
            // state_id: stateName,
            // city_id: cityName,
            // zipcode_id: zipCodeId,
            address: address,
            bussiness_name: legalBusinessname,
            active: 1,
            createdBy: successData.seller_id,
            updatedBy: successData.seller_id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        };
        console.log("===", request)
        // return


        if (!firstname) {
            setFirstNameError("First Name is required")
            return;
        }
        else if (firstname.length > 50) {
            setFirstNameError("First Name must not exceed 50 characters")
            return;
        }
        if (!lastname) {
            setLastNameError("Last Name is required")
            return;
        }
        else if (lastname.length > 50) {
            setLastNameError("Last Name must not exceed 50 characters ")
            return;
        }
        if (!legalBusinessname) {
            setLegalBusinessnameError("Legal Businessname is required")
            return;
        }
        else if (legalBusinessname.length > 50) {
            setLegalBusinessnameError("Legal Businessname must not exceed 50 Characters ")
            return;
        }
        if (!EINnumber) {
            setEINnumberError("EIN Number is required")
            return;
        }
        else if (EINnumber.length < 10) {
            setEINnumberError("EIN # Must Have Nine Digits")
            return;
        }
        if (!dealershiplicense) {
            setDealershiplicenseError("Dealership License is required")
            return;
        }
        else if (dealershiplicense.length > 50) {
            setDealershiplicenseError("Dealership License must not exceed 50 digits ")
            return;
        }
        if (!taxid) {
            setTaxidError("Tax Id is required")
            return;
        }
        else if (taxid.length > 50) {
            setTaxidError("Tax Id must not exceed 50 digits ")
            return;
        }
        if (!address) {
            setAddressError("Address is required")
            return;
        }
        else if (address.length > 150) {
            setAddressError("Address must not exceed 150 characters")
            return;
        }
        if (!idStatename) {
            setStateAndCityError("1")
            return
        }
        if (!idCityname) {
            setStateAndCityError("2")
            return
        }
        if (!idZipcodename) {
            setStateAndCityError("3")
            return
        }
        if (!dealershipLicenseexp) {
            setDealershiplicenseexpError("Dealership Licenseexp is required")
            return;
        }
        if (!taxidexp) {
            setTaxidexpError("Tax Idexp is required")
            return;
        }


        API.post("seller_legal_manage/add", request)
            .then((response) => {
                if (response.data.success) {
                    const { data } = response;
                    togglePopup()
                    setPopupTitle("Create Legal manage account");
                    setPopupMsg("Legal manage account is successfully created");
                    setPopupType("success");
                    setPopupActionType("redirect");
                    setPopupActionValue("ok");
                    setPopupActionPath("/manageaccount")

                } else {
                    togglePopup()
                    setPopupTitle("Create Legal manage account");
                    // setPopupMsg("Legal manage account is not Created, Please try Again");
                    setPopupMsg(response.data.error.err);
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            }, (error) => {
                // setOpenLoader(false);
                // console.log(error);
                togglePopup()
                setPopupTitle("Error");
                setPopupMsg("Something went wrong, Please try Again");
                setPopupType("error");
                setPopupActionType("close");
                setPopupActionValue("close");
            })
            .catch(function (error) {
                if (error.response) {
                    setAddErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });


    }

    const getStateName = (stateData, flag) => {
        setIdStatename(stateData)
        setStateCityFlag(flag)
        if (flag === "") {
            setIdCityname(null)
            setidZipcodename(null)
        }
    }

    const getCityName = (cityData, flag) => {
        setIdCityname(cityData)
        if (flag === "") {
            setidZipcodename(null)
        }
    }

    const getZipCodeId = (zipData) => {
        setidZipcodename(zipData)
    }

    const getError = (data, flag) => {
        console.log("reg flag", data, flag);
        setAddErrors(data)
        setErrorFlag(flag)
    }

    // const getStateName = (stateData) => {
    //     setStateName(stateData)
    //     setCityName(null)
    //     setZipcodeId(null)
    // }

    // const getCityName = (cityData) => {
    //     setCityName(cityData)
    //     setZipcodeId(null)
    // }

    // const getZipCodeId = (zipData) => {
    //     setZipcodeId(zipData)
    // }

    const inputProps1 = {
        placeholder: "YYYY/MM/DD",
        value: dealershipLicenseexp
    };
    const inputProps2 = {
        placeholder: "YYYY/MM/DD",
        value: taxidexp
    };

    const Date1 = (event) => {
        if (event._isAMomentObject == true) {
            setDealershiplicenseexp(event.format("YYYY/MM/DD"))
        }
    }
    const Date2 = (event) => {
        if (event._isAMomentObject == true) {
            setTaxidexp(event.format("YYYY/MM/DD"))
        }
    }

    useEffect(() => {
        setIdStatename(idStatename)
        setIdCityname(idCityname)
        setidZipcodename(idZipcodename)
    }, []);

    const handleEINChange = (e) => {
        const inputSSN = e.target.value.replace(/\D/g, "");
        const inputLength = inputSSN.length;

        let formattedSSN = "";

        if (inputLength > 0) {
            formattedSSN = inputSSN.slice(0, 2);
            console.log("first 2 numbers", formattedSSN)
        }
        if (inputLength > 2) {
            formattedSSN += "-" + inputSSN.slice(2, 9);
            console.log("next 2 numbers", formattedSSN)

        }

        setEINnumber(formattedSSN);
    };

    return (
        <div>
            <main id="main" className="inner-page">
                {errorFlag === true ? <PageNotFound error={addErrors} /> :
                    <div id="addaddress" className="addaddress_block">
                        <div className="container" >
                            <div className="addaddressblock col-lg-12">
                                <div className="section-title">
                                    <h2>Add Legal Manage Account</h2>
                                </div>
                                <div className="row content">
                                    <div className="col-lg-3 col-md-4 col-sm-12 mgaccountleftblock">

                                        <ManageAccountLinks />
                                    </div>
                                    <div className="col-lg-9 col-md-8 col-sm-12 pt-4 pt-lg-0  flooraddform">
                                        <div className="adduserpage-inner">
                                            <div className="col-lg-12">
                                                <form className="registrationform"  >
                                                    <div className="row">

                                                        <div className="section-title">
                                                            <button className="back-btn-paymentform backBtn" onClick={() => history.push("/manageaccount")}><i className="icofont-arrow-left"></i> Back</button>
                                                            <h2>Add Legal Manage Account</h2>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="contactName" className="textbox" placeholder="" name="firstName"

                                                                    onChange={(e) => setFirstname(e.target.value)} />
                                                                <label htmlFor="contactName" className={firstname != "" ? "input-has-value required" : "required"}>First Name</label>

                                                                <p className="form-input-error" >{firstNameError}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="companyName" className="textbox" placeholder="" name="lastname"

                                                                    onChange={(e) => setLastname(e.target.value)} />
                                                                <label htmlFor="companyName" className={lastname != "" ? "input-has-value required" : "required"}>Last Name</label>

                                                                <p className="form-input-error" >{lastNameError}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="branchName" className="textbox" placeholder="" name="legalBusinessname"

                                                                    onChange={(e) => setLegalBusinessname(e.target.value)} />
                                                                <label htmlFor="branchName" className={legalBusinessname != "" ? "input-has-value required" : "required"}>Legal Business Name</label>

                                                                <p className="form-input-error" >{legalBusinessnameError}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="accountNumber" className="textbox" placeholder="" name="EINnumber"
                                                                    value={EINnumber}
                                                                    onChange={handleEINChange} />
                                                                <label htmlFor="accountNumber" className={EINnumber != "" ? "input-has-value required" : "required"}>EIN Number</label>

                                                                <p className="form-input-error" >{EINnumberError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="creditLimit" className="textbox" placeholder="" name="dealershiplicense"

                                                                    onChange={(e) => setDealershiplicense(e.target.value)} />
                                                                <label htmlFor="creditLimit" className={dealershiplicense != "" ? "input-has-value required" : "required"}>Dealership License</label>

                                                                <p className="form-input-error" >{dealershiplicenseError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="emailId" className="textbox" placeholder="" name="taxid"

                                                                    onChange={(e) => setTaxid(e.target.value)} />
                                                                <label htmlFor="emailId" className={taxid != "" ? "input-has-value required" : "required"}>Tax Id</label>

                                                                <p className="form-input-error" >{taxidError}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="address" className="textbox" placeholder="" name="address"

                                                                    onChange={(e) => setAddress(e.target.value)} />
                                                                <label htmlFor="address" className={address != "" ? "input-has-value required" : "required"}>Address</label>

                                                                <p className="form-input-error" >{addressError}</p>
                                                            </div>
                                                        </div>
                                                        <StateAndCitySearch
                                                            setStateValue={getStateName}
                                                            setCityValue={getCityName}
                                                            setZipcodeValue={getZipCodeId}
                                                            setNewError={getError}
                                                            stateCityValidation={stateAndCityError}
                                                            setRequired="true"

                                                        />
                                                        {/* <div className="col-sm-12 form-group">
                                                        <p className="form-input-error2"> {stateAndCityError}</p>
                                                    </div> */}

                                                        {/* <div className="col-sm-12 form-group">
                            <div className="tbox">                            
                                <input type="text" id="phoneNumber" className="textbox" placeholder="" required onChange={(e) => setCity(e.target.value)} />
                                <label htmlFor="phoneNumber" className={city !="" ? "input-has-value" : ""}>City</label>
                            </div>
                            </div>   
                            <div className="col-sm-12 form-group">
                             <div className="tbox">                            
                                <input type="text" id="phoneNumber" className="textbox" placeholder="" required onChange={(e) => setState(e.target.value)} />
                                <label htmlFor="phoneNumber" className={state !="" ? "input-has-value" : ""}>State</label>
                            </div>
                            </div>                                     
                            <div className="col-sm-12 form-group">
                             <div className="tbox">                            
                                <input type="number" id="phoneNumber" className="textbox" placeholder="" required onChange={(e) => setZipcode(e.target.value)} />
                                <label htmlFor="phoneNumber" className={zipcode !="" ? "input-has-value" : ""}>Zip code</label>
                            </div> 
                            </div>  */}
                                                        <div className="col-sm-12 form-group datePickerBlock">
                                                            <div className="tbox">
                                                                <Datetime inputProps={inputProps1} timeFormat={false} dateFormat="YYYY/MM/DD"
                                                                    name="Date" id="ldate" isValidDate={disablePastDt} onChange={Date1} closeOnSelect={true}
                                                                    class="form-control textbox" />
                                                                <label htmlFor="ldate" className={dealershipLicenseexp != "" ? "input-has-value required" : "required"}>Seller License Exp</label>

                                                            </div>
                                                            {/* <label htmlFor="first_name" className={dealershipLicenseexp !="" ? "input-has-value" : ""}>Seller license exp</label> */}

                                                            <p className="form-input-error" >{dealershipLicenseexpError}</p>
                                                        </div>
                                                        <div className="col-sm-12 form-group datePickerBlock">
                                                            <div className="tbox">
                                                                <Datetime inputProps={inputProps2} timeFormat={false} dateFormat="YYYY/MM/DD" closeOnSelect={true}
                                                                    class="form-control textbox" id="edate" name="Date" isValidDate={disablePastDt} onChange={Date2}
                                                                />
                                                                <label htmlFor="edate" className={taxidexp != "" ? "input-has-value required" : "required"}>Tax Id Exp Date</label>

                                                            </div>
                                                            {/* <label htmlFor="first_name" className={taxidexp!="" ? "input-has-value" : ""}>Tax id exp</label> */}

                                                            <p className="form-input-error" >{taxidexpError}</p>

                                                        </div>


                                                        <div className="col-lg-12 loginBtn">
                                                            <Button className="cta-btn " style={customButtonStyle} onClick={() => setConfirmationFlag(true)}>Submit</Button>
                                                        </div>
                                                    </div>
                                                </form>

                                            </div>  </div></div></div></div></div></div>}
                {confirmationFlag &&

                    <div className="popup-box">
                        <div id="" className="CommonModels-box">
                            <div className="Commonfullformblock col-lg-9">
                                <div className="CommonContainer">
                                    <div className="CommonModalcontent">
                                        <div className="CommonModalbody">
                                            <h2>Edit confirmation</h2>
                                            <p>Are you sure,If you want to Add Legal Account Information please confirm</p>
                                        </div>
                                        <div className="CommonModalfooter">
                                            <div className="CommonModalfooter session">
                                                <button className="cta-btn btn-smlprimary" onClick={confirmationPopup} >CANCEL</button>
                                                <button className="cta-btn btn-smlprimary" onClick={onhandleSubmit}  >OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                <section id="playstoreBlock" className="playstoreBlock">
                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-12">
                                <img src={appstore} />
                                <img src={googleplay} />
                            </div>
                        </div>
                    </div>
                </section>
                {isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                    />}
            </main>
        </div>


    )
}

export default AddLegalAccount;